export default class Constants {
  static CAMPAIGN_EFFECTS = {
    GET_EMAILS: 'getEmails',
	GET_SNS_ACCOUNTS: 'getSnsAccounts',
	GET_FOLLOWERS: 'getFollowers',
	GET_HIGH_SPREAD: 'getHighSpread',
	GET_MIDDLE_SPREAD: 'getMiddleSpread',
	GET_FRIENDS: 'getFriends',
	GET_USER_INFO: 'getUserInfo',
	SALE_PROMOTION: 'salesPromotion',
	CONNECT_LINE_BUSINESS: 'connectLineBusiness',
	REDUCE_UN_FOLLOW: 'reduceUnfollow',
	INCREASED_SALES: 'increasedSales',
	GET_CUSTOMER_LEAD: 'getCustomerLead',
	INCREASED_ENGAGEMENT: 'increasedEngagement',
	CONNECT_WATCHING: 'continueWatching',
	VERIFIED_BADGE: 'verifiedBadge',
	RETENTION: 'retention',
	GAIN_RECOGNITION: 'gainRecognition',
	UGC: 'UGC',
	INCREASED_VISIT_STORE: 'increasedVisitStore',
  }
}